import { Component, OnInit } from '@angular/core';
import {
  createEntityRole,
  loadEntityRoleDetails,
  RolesFacade,
  setSelectedRole,
  updateEntityRole,
} from '@boma/supplier-portal/users';
import { IRole, RoleAuthTarget } from '@boma/client-shared';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PermissionsFacade } from '../../../+state/permissions/permissions.facade';
import { deleteRole } from '@boma/administration-portal/users';
import { Store } from '@ngrx/store';
import { getSelectedOrganizationInfo } from '@boma/supplier-portal/shared/state';
import { filter, take, tap } from 'rxjs/operators';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'boma-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
})
export class IndexComponent implements OnInit {
  form: IRole;
  columns = [{ field: 'name', header: 'Name' }];
  roles$ = this.rolesFacade.customRoles$;
  presetRoles$ = this.rolesFacade.presetEntityRoles$;
  loaded$ = this.rolesFacade.loaded$;
  targetTypes: { label: string; value: number }[];

  createFormGroup: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    target: new FormControl(
      [RoleAuthTarget.Entity.valueOf()],
      Validators.required
    ),
    description: new FormControl('', Validators.required),
    permissions: new FormControl('', Validators.required),
  });

  updateFormGroup: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    target: new FormControl('', Validators.required),
    description: new FormControl('', Validators.required),
    permissions: new FormControl('', Validators.required),
  });

  // friendlyRoleNames = [
  //   {
  //     label: 'View Users',
  //     permissionName: 'view-users',
  //     modules: [],
  //   },
  //   {
  //     label: 'Add Users',
  //     permissionName: 'add-users',
  //     modules: [],
  //   },
  //   {
  //     label: 'Add Users',
  //     permissionName: 'add-users',
  //     modules: [],
  //   },
  // ];

  //
  // ViewUsers = "view-users";
  // AddUsers = "add-users";
  // EditUsers = "edit-users";
  // DeleteUsers = "delete-users";
  //
  // ViewAdministrators = "view-administrators";
  // AddAdministrators = "add-administrators";
  // EditAdministrators = "edit-administrators";
  // DeleteAdministrators = "delete-administrators";
  //
  // ViewEntityRoles = "view-entity-roles";
  // AddEntityRoles = "add-entity-roles";
  // EditEntityRoles = "edit-entity-roles";
  // DeleteEntityRoles = "delete-entity-roles";
  //
  // ViewLocations = "view-locations";
  // AddLocations = "add-locations";
  // EditLocations = "edit-locations";
  // DeleteLocations = "delete-locations";
  //
  // ViewProducts = "view-products";
  // AddProducts = "add-products";
  // EditProducts = "edit-products";
  // DeleteProducts = "delete-products";
  //
  // ViewBrands = "view-brands";
  // AddBrands = "add-brands";
  // EditBrands = "edit-brands";
  // DeleteBrands = "delete-brands";
  //
  // ViewInventory = "view-inventory";
  // AddInventory = "add-inventory";
  // EditInventory = "edit-inventory";
  // DeleteInventory = "delete-inventory";
  //
  // ViewStockIn = "view-stock-in";
  // ViewStockOut = "view-stock-out";
  // AddStockIn = "add-stock-in";
  // AddStockOut = "add-stock-out";
  //
  // ViewPricing = "view-pricing";
  // AddPricing = "add-pricing";
  // EditPricing = "edit-pricing";
  // DeletePricing = "delete-pricing";
  //
  // ViewPricingPromotions = "view-pricing-promotions";
  // AddPricingPromotions = "add-pricing-promotions";
  // EditPricingPromotions = "edit-pricing-promotions";
  // DeletePricingPromotions = "delete-pricing-promotions";
  //
  // ViewCustomerPricing = "view-customer-pricing";
  // AddCustomerPricing = "add-customer-pricing";
  // EditCustomerPricing = "edit-customer-pricing";
  // DeleteCustomerPricing = "delete-customer-pricing";
  //
  // ViewVehicles = "view-vehicles";
  // AddVehicles = "add-vehicles";
  // EditVehicles = "edit-vehicles";
  // DeleteVehicles = "delete-vehicles";
  //
  // ViewDrivers = "view-drivers";
  // AddDrivers = "add-drivers";
  // EditDrivers = "edit-drivers";
  // DeleteDrivers = "delete-drivers";
  //
  // ViewNotificationTriggers = "view-notification-triggers";
  // AddNotificationTriggers = "add-notification-triggers";
  // EditNotificationTriggers = "edit-notification-triggers";
  // DeleteNotificationTriggers = "delete-notification-triggers";
  //
  // ViewSales = "view-sales"; // More of a front end control as sales are technically orders.
  // AddSales = "add-sales"; // More of a front end control as sales are technically orders.
  //
  // ViewTransfers = "view-transfers"; // More of a front end control as sales are technically orders.
  //
  // ViewStocks = "view-stocks-events"; // More of a front end control as sales are technically orders.
  //
  //
  // ViewOrders = "view-orders";
  // AddOrders = "add-orders";
  // AddOrderTransfers = "add-order-transfers";
  // AddCustomerOrders = "add-customer-order";
  // SetHandshakeRequirement = "set-handshake-requirement";
  // EditOrders = "edit-orders";
  // DeleteOrders = "delete-orders";
  // CancelOrders = "cancel-orders";
  // CancelOrdersAfterDispatched = "cancel-orders-after-dispatched";
  // UpdatePaymentForOrders = "update-payment-for-orders";
  // UpdateOrderItemPricing = "update-order-item-pricing";
  //
  // ViewCartItems = "view-cart-items";
  // AddCartItems = "add-cart-items";
  // EditCartItems = "edit-cart-items";
  // DeleteCartItems = "delete-cart-items";
  //
  // ViewDetails = "view-details";
  // AddDetails = "add-details";
  // EditDetails = "edit-details";
  // DeleteDetails = "delete-details";
  //
  // ViewCashPosition = "view-cash-position-entries";
  // AddCashPosition = "add-cash-position-entries";
  // EditCashPosition = "edit-cash-position-entries";
  // DeleteCashPosition = "edit-cash-position-entries";
  //
  // ViewJournal = "view-journal";
  // AddJournal = "add-journal";
  // EditJournal = "edit-journal";
  // DeleteJournal = "delete-journal";
  //
  // ViewCustomers = "view-customers";
  // AddCustomers = "add-customers";
  // EditCustomers = "edit-customers";
  // DeleteCustomers = "delete-customers";
  //
  // ViewFeedItems = "view-feed-items";
  // AddFeedItems = "add-feed-items";
  // EditFeedItems = "edit-feed-items";
  // DeleteFeedItems = "delete-feed-items";
  //
  // ViewInformalListings = "view-informal-listings";
  // AddInformalListings = "add-informal-listings";
  // EditInformalListings = "edit-informal-listings";
  // DeleteInformalListings = "delete-informal-listings";
  //
  // ViewSalesRecordReport = "view-sales-record-report";
  // ViewDailySalesReport = "view-daily-sales-report";
  // ViewCashUpReport = "view-cash-up-report";
  // ViewDepositsReport = "view-deposit-report";
  //
  // ViewStockReport = "view-stock-report";
  //
  // ViewDefinitions = "view-definitions";
  // AddDefinitions = "add-definitions";
  // EditDefinitions = "edit-definitions";
  // DeleteDefinitions = "delete-definitions";
  //
  // ViewBetaFeatures = "view-beta-features";

  constructor(
    public rolesFacade: RolesFacade,
    public permissionsFacade: PermissionsFacade,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.permissionsFacade.dispatchGetPermissionsForTarget('Entities');
    this.targetTypes = Object.keys(RoleAuthTarget)
      .filter((e) => isNaN(Number(e)))
      .map((value) => {
        if (value !== 'Administration')
          return {
            label: value,
            value: RoleAuthTarget[value],
          };
      })
      .filter((v) => v);
    this.rolesFacade.loadEntityRoles();
    this.rolesFacade.loadLocationRoles();
    this.createFormGroup.valueChanges.subscribe((v) =>
      console.log('Changes: ', v)
    );
  }

  onCreateSubmit() {
    this.store
      .select(getSelectedOrganizationInfo)
      .pipe(
        filter((org) => !!org),
        take(1)
      )
      .subscribe((org) => {
        const target = (
          this.createFormGroup.value.target as number[]
        ).reduce<number>(
          (previousValue, currentValue) => previousValue + currentValue,
          0
        );
        this.rolesFacade.dispatch(
          createEntityRole({
            request: {
              ...this.createFormGroup.value,
              target,
              entityId: org.id,
            },
          })
        );
        this.createFormGroup.reset();
      });
  }

  handleUpdateSelection(data) {
    this.rolesFacade.dispatch(setSelectedRole({ roleId: data.id }));
    this.rolesFacade.dispatch(loadEntityRoleDetails({ id: data.id }));

    //we have a problem here role loads as undefined the first time..
    // there after it keeps loading the previous value not the current ont
    this.rolesFacade.selectedRoles$
      .pipe(
        filter((role) => !!role && !!role.permissions?.length),
        take(1)
      )
      .subscribe((role) => {
        if (role && role.permissions) {
          this.updateFormGroup.patchValue({
            ...role,
            target: this.decomposeRoleAuthValue(role.target),
          });
        }
      });
  }

  onUpdateSubmit() {
    combineLatest([
      this.store.select(getSelectedOrganizationInfo),
      this.rolesFacade.selectedRoles$,
    ])
      .pipe(
        filter((org) => !!org),
        take(1)
      )
      .subscribe((data) => {
        const target = (
          this.updateFormGroup.value.target as number[]
        ).reduce<number>(
          (previousValue, currentValue) => previousValue + currentValue,
          0
        );
        const org = data[0];
        const selectedRole = data[1];
        const role = { ...this.updateFormGroup.value, target };
        this.rolesFacade.dispatch(
          updateEntityRole({
            request: { ...role, entityId: org.id },
            roleId: selectedRole.id,
          })
        );
      });
  }

  onItemDeleted(data) {
    this.rolesFacade.dispatch(deleteRole({ roleId: data.id }));
  }

  private decomposeRoleAuthValue(value: number): RoleAuthTarget[] {
    const result: RoleAuthTarget[] = [];

    if (value & RoleAuthTarget.Administration) {
      result.push(RoleAuthTarget.Administration);
    }

    if (value & RoleAuthTarget.Entity) {
      result.push(RoleAuthTarget.Entity);
    }

    if (value & RoleAuthTarget.Location) {
      result.push(RoleAuthTarget.Location);
    }

    if (value & RoleAuthTarget.Vehicle) {
      result.push(RoleAuthTarget.Vehicle);
    }

    return result;
  }
}
